import { jsx } from "panel";
import { ToastEl } from "common/components/toast";
export function template() {
  const {
    toasts
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-toast-area", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, toasts.map((toast) => /* @__PURE__ */ jsx(ToastEl, { on: {
    action: () => this.helpers.toastAction(toast),
    close: () => this.helpers.toastClose(toast),
    undo: () => this.helpers.toastUndo(toast)
  }, attrs: {
    cta: toast.cta || "",
    "cta-href": toast.ctaHref || "",
    "cta-target": toast.ctaTarget || "",
    elref: toast.elref || "toast".concat(toast.id),
    hide: toast.hide,
    "hide-cancel-button": toast.hideCancelButton,
    "is-error": toast.isError,
    undoable: toast.undoable,
    "undo-label": toast.undoLabel || "Undo",
    timeout: toast.isStatic ? null : toast.timeout,
    type: toast.type
  } }, typeof toast.message === "function" ? this.getContext("i18n").print(toast.message) : toast.message)));
}
